import {atom} from 'recoil';
import {recoilPersist} from 'recoil-persist'

const {persistAtom} = recoilPersist()

export const defaultValue = {title: "", content: "", payUSD: null, payMIL: null}

const paymentAtom = atom({
    key: 'payment',
    default: defaultValue,
    effects_UNSTABLE: [persistAtom],
});

export {paymentAtom};
